import { PageTypeEnum, WebsitePageType } from 'common/enums/PageTypeEnum'

export const creatablePageTypes: {
  type: Extract<
    WebsitePageType,
    PageTypeEnum.WebsiteDefault | PageTypeEnum.WebsiteLogin
  >
  label: string
}[] = [
  {
    type: PageTypeEnum.WebsiteDefault,
    label: 'website.page_types.website_static',
  },
  // {
  //   type: PageTypeEnum.WebsiteLogin,
  //   label: 'website.page_types.website_login',
  // },
]
